import { Header } from "../components/sections/Header";
import { Hero } from "../components/sections/Hero";
import { History } from "../components/sections/History";
import { Competition } from "../components/sections/Competition";
import { MatchDay } from "../components/sections/MatchDay";
import { Stats } from "../components/sections/Stats";
import { Multimedia } from "../components/sections/Multimedia";
import { Footer } from "../components/sections/Footer";

// Sitio de la temporada anterior (Agosto 2026), conservado como archivo.
export const TemporadaAgosto26 = () => {
  return (
    <div className="min-h-screen bg-white text-[#061930]">
      <Header />
      <main>
        <Hero />
        <History />
        <Competition />
        <MatchDay />
        <Stats />
        <Multimedia />
      </main>
      <Footer />
    </div>
  );
};
